module.exports = __webpack_public_path__ + "static/media/micro373.2b28eda9.jpg";